const ResultTypes = {
    ATTEMPTED: "attempted",
    CORRECT: "totalCorrect",
    COUNT: "count",
    INCORRECT: "totalIncorrect",
    LABEL: "label",
    LABEL_RETEST: "labelRetest",
    OMITTED: "totalOmitted",
    REGULAR: "regular",
    RETEST: "retest",
    RETEST_TOTAL_CORRECT: "totalCorrect_retest",
    RETEST_TOTAL_INCORRECT: "totalIncorrect_retest",
    RETEST_TOTAL_OMITTED: "totalOmitted_retest",
};

export default ResultTypes;
